import {IntermediatePart} from "../../intermediatePart";
import {PLACEMENTS} from "../../constants";
import Cabinet from "../../parts/cabinet";

export default class Stovetop extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'stovetop';
    this.partName = 'Stovetop';
    this.translateId = "visualizer.kitchen.countertop.stovetop";
  }

  load(dbFeature) {
    if (dbFeature.metaData && dbFeature.metaData["Placement"]
      && !dbFeature.metaData["Placement"].includes(PLACEMENTS.Countertop)) {
      return false
    }
    return super.load_(dbFeature, new Stovetop());
  }

  setLayers(layout) {

    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const bottomCabinet = cabinetParent && cabinetParent.bottomCabinet;
    if (bottomCabinet && (bottomCabinet.disabled || !bottomCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.CountertopGroup.Stovetop;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
    }
  }
}
